{
  "familyId": "TAA-SOORT-TW",
  "questions": [
    {
      "id": "TAA-SOORT-TW-001",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is een telwoord in deze zin? 'Er staan drie bomen in de tuin.'",
      "options": ["drie", "bomen", "staan", "tuin"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wat is een telwoord?", "content": "Een telwoord geeft een aantal of volgorde aan.\n\nHoofdtelwoorden: één, twee, drie, tien, honderd\nRangtelwoorden: eerste, tweede, derde, tiende\n\nVraag: hoeveel? of de hoeveelste?", "icon": "lightbulb" } }
      ],
      "conceptId": "telwoord_herkennen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Drie' is een telwoord — het geeft een aantal aan (hoeveel bomen?). 'Bomen' is een zelfstandig naamwoord, 'staan' is een werkwoord, 'tuin' is een zelfstandig naamwoord.",
        "solutionSteps": ["Vraag: welk woord geeft een aantal aan?", "'Drie' → hoeveel bomen? Drie! → telwoord"],
        "distractorExplanations": {
          "0": "Goed! 'Drie' is een hoofdtelwoord (geeft aantal aan).",
          "1": "'Bomen' is een zelfstandig naamwoord (je kunt er 'de' of 'het' voor zetten).",
          "2": "'Staan' is een werkwoord (het geeft een handeling aan).",
          "3": "'Tuin' is een zelfstandig naamwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-TW-002",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is een RANGtelwoord?",
      "options": ["derde", "drie", "drietal", "driedubbel"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofd- vs. rangtelwoord", "content": "Hoofdtelwoord: geeft AANTAL aan → hoeveel? (drie, tien, honderd)\nRangtelwoord: geeft VOLGORDE aan → de hoeveelste? (derde, tiende, honderdste)\n\nRangtelwoorden eindigen vaak op -de of -ste.", "icon": "lightbulb" } }
      ],
      "conceptId": "telwoord_rang_herkennen",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Derde' is een rangtelwoord — het geeft volgorde aan (de hoeveelste?). 'Drie' is een hoofdtelwoord (hoeveel?). 'Drietal' en 'driedubbel' zijn geen telwoorden maar samenstellingen.",
        "solutionSteps": ["Rangtelwoord = volgorde (de hoeveelste?)", "'Derde' → de derde plek → rangtelwoord", "Eindigt op -de → typisch rangtelwoord"],
        "distractorExplanations": {
          "0": "Goed! 'Derde' is een rangtelwoord (volgorde).",
          "1": "'Drie' is een hoofdtelwoord (aantal), geen rangtelwoord.",
          "2": "'Drietal' is een zelfstandig naamwoord (een groep van drie).",
          "3": "'Driedubbel' is een bijvoeglijk naamwoord."
        }
      }
    },
    {
      "id": "TAA-SOORT-TW-003",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "multiple_choice",
      "question": "Hoeveel telwoorden staan er in deze zin? 'De tweede leerling maakte vijf fouten in de eerste opdracht.'",
      "options": ["3 (tweede, vijf, eerste)", "2 (tweede, eerste)", "1 (vijf)", "4"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Telwoorden tellen", "content": "Hoofdtelwoorden: vijf (hoeveel fouten?)\nRangtelwoorden: tweede (de hoeveelste leerling?), eerste (de hoeveelste opdracht?)\n\nAlledrie zijn telwoorden!", "icon": "lightbulb" } }
      ],
      "conceptId": "telwoord_tellen_in_zin",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Er staan 3 telwoorden: 'tweede' (rangtelwoord), 'vijf' (hoofdtelwoord), 'eerste' (rangtelwoord). Zowel hoofd- als rangtelwoorden zijn telwoorden!",
        "solutionSteps": ["'Tweede' → rangtelwoord (de hoeveelste?)", "'Vijf' → hoofdtelwoord (hoeveel?)", "'Eerste' → rangtelwoord (de hoeveelste?)", "Totaal: 3 telwoorden"],
        "distractorExplanations": {
          "0": "Goed! Tweede, vijf en eerste zijn alle drie telwoorden.",
          "1": "Je vergeet 'vijf'. Dat is ook een telwoord (hoofdtelwoord).",
          "2": "Je vergeet 'tweede' en 'eerste'. Rangtelwoorden zijn ook telwoorden!",
          "3": "Er zijn er maar 3, niet 4. Welk vierde woord bedoel je?"
        }
      }
    },
    {
      "id": "TAA-SOORT-TW-004",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "multiple_choice",
      "question": "Welk woord is GEEN telwoord?",
      "options": ["veel", "twintig", "eerste", "honderd"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Telwoord of onbepaald?", "content": "Telwoorden geven een EXACT aantal of volgorde aan: drie, twintig, honderd, eerste, derde.\n\n'Veel', 'weinig', 'enkele' geven een ONBEPAALDE hoeveelheid aan → onbepaald voornaamwoord, geen telwoord.", "icon": "lightbulb" } }
      ],
      "conceptId": "telwoord_vs_onbepaald",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Veel' is geen telwoord maar een onbepaald voornaamwoord — het geeft geen exact aantal aan. 'Twintig', 'eerste' en 'honderd' zijn wél telwoorden (exact aantal of volgorde).",
        "solutionSteps": ["'Veel' → onbepaalde hoeveelheid → geen telwoord", "'Twintig' → exact aantal → hoofdtelwoord", "'Eerste' → volgorde → rangtelwoord", "'Honderd' → exact aantal → hoofdtelwoord"],
        "distractorExplanations": {
          "0": "Goed! 'Veel' is geen telwoord maar een onbepaald voornaamwoord.",
          "1": "'Twintig' is wél een telwoord (hoofdtelwoord: exact aantal).",
          "2": "'Eerste' is wél een telwoord (rangtelwoord: volgorde).",
          "3": "'Honderd' is wél een telwoord (hoofdtelwoord: exact aantal)."
        }
      }
    },
    {
      "id": "TAA-SOORT-TW-005",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "fill_in",
      "question": "Maak van het hoofdtelwoord 'vier' een rangtelwoord. Typ het woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["vierde"],
        "caseSensitive": false,
        "placeholder": "vier..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Rangtelwoord maken", "content": "Voeg -de of -ste toe aan het hoofdtelwoord:\nvier → vierde\ntien → tiende\nhonderd → honderdste\n\nRegel: 1-19 → -de, vanaf 20 → -ste.", "icon": "lightbulb" } }
      ],
      "conceptId": "telwoord_rang_maken_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Vier → vierde. Voeg -de toe aan het hoofdtelwoord. Rangtelwoorden van 1-19 eindigen op -de (eerste, tweede, derde, vierde...).",
        "solutionSteps": ["Hoofdtelwoord: vier", "Voeg -de toe: vierde", "Vierde = rangtelwoord (de hoeveelste?)"]
      }
    },
    {
      "id": "TAA-SOORT-TW-006",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "categorize",
      "question": "Sorteer de telwoorden: is het een hoofdtelwoord (aantal) of een rangtelwoord (volgorde)?",
      "data": {
        "categories": ["Hoofdtelwoord", "Rangtelwoord"],
        "items": [
          { "text": "vijf", "correctCategory": 0 },
          { "text": "eerste", "correctCategory": 1 },
          { "text": "honderd", "correctCategory": 0 },
          { "text": "derde", "correctCategory": 1 },
          { "text": "twaalf", "correctCategory": 0 },
          { "text": "zevende", "correctCategory": 1 },
          { "text": "duizend", "correctCategory": 0 },
          { "text": "tiende", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofd- vs. rangtelwoord",
            "content": "Hoofdtelwoord = HOEVEEL? (vijf, twaalf, honderd, duizend). Rangtelwoord = DE HOEVEELSTE? (eerste, derde, zevende, tiende). Rangtelwoorden eindigen vaak op -de of -ste.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "telwoord_categoriseer_hoofd_rang",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Hoofdtelwoorden geven een aantal aan (hoeveel?): vijf, honderd, twaalf, duizend. Rangtelwoorden geven volgorde aan (de hoeveelste?): eerste, derde, zevende, tiende.",
        "solutionSteps": [
          "Vraag: geeft het woord een AANTAL aan? → hoofdtelwoord",
          "Vraag: geeft het woord een VOLGORDE aan? → rangtelwoord",
          "Rangtelwoorden eindigen vaak op -de of -ste"
        ]
      }
    },
    {
      "id": "TAA-SOORT-TW-007",
      "familyId": "TAA-SOORT-TW",
      "module": "Taalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "woordsoorten",
      "subSkill": "srt_telwoord",
      "questionType": "matching",
      "question": "Koppel elk hoofdtelwoord aan het bijbehorende rangtelwoord.",
      "data": {
        "pairs": [
          { "left": "één", "right": "eerste" },
          { "left": "twee", "right": "tweede" },
          { "left": "drie", "right": "derde" },
          { "left": "acht", "right": "achtste" },
          { "left": "twintig", "right": "twintigste" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofd- → rangtelwoord",
            "content": "Meestal voeg je -de of -ste toe: vier → vierde, twintig → twintigste. Uitzonderingen: één → eerste, drie → derde. Vanaf 20 gebruik je -ste.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "telwoord_matching_hoofd_rang",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Hoofdtelwoorden worden rangtelwoorden door -de of -ste toe te voegen. Let op uitzonderingen: één → eerste, drie → derde. Vanaf 20: -ste (twintigste).",
        "solutionSteps": [
          "Voeg -de of -ste toe aan het hoofdtelwoord",
          "Uitzonderingen: één → eerste, drie → derde",
          "Vanaf 20: -ste (twintigste, dertigste)"
        ]
      }
    }
  ]
}